"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    supplier: 'Leverantör' || 'supplier',
    setOwningSupplierOrganization: 'Ändra ägare av leverantör' || 'setOwningSupplierOrganization',
    suggestNewSupplier: 'Tipsa om ny leverantör eller artikel!' || 'suggestNewSupplier',
    ensureOrders: 'Räkna om order för tidsperiod' || 'ensureOrders',
    requestDemo: 'BOKA DEMO' || 'requestDemo',
    writeSupplier: 'Spara leverantör' || 'writeSupplier',
    disconnectFromExtend: 'Koppla bort från Extend' || 'disconnectFromExtend',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    supplierNumber: 'Leverantörsnummer' || 'supplierNumber',
    currency: 'Valuta' || 'currency',
    name: 'Namn' || 'name',
    logo: 'Logotyp' || 'logo',
    organisationNumber: 'Organisationsnummer' || 'organisationNumber',
    ourReference: 'Kontaktperson' || 'ourReference',
    email: 'E-post för avräkning och lagerrapport' || 'email',
    emailForPurchaseOrder: 'E-post för inleverans' || 'emailForPurchaseOrder',
    phone: 'Telefonnummer' || 'phone',
    bank: 'Bank' || 'bank',
    bg: 'Bankgiro' || 'bg',
    pg: 'Postgiro' || 'pg',
    bic: 'BIC' || 'bic',
    iban: 'IBAN' || 'iban',
    homepage: 'Webbsida' || 'homepage',
    utilitySupplier: 'Z-markerad' || 'utilitySupplier',
    active: 'Aktiverad' || 'active',
    invoiceAddress: 'Adress' || 'invoiceAddress',
    invoiceZipCode: 'Postnummer' || 'invoiceZipCode',
    invoiceCity: 'Stad' || 'invoiceCity',
    invoiceCountry: 'Land' || 'invoiceCountry',
    invoiceCountries: {
        SE: 'Sverige' || 'SE',
        FI: 'Finland' || 'FI',
        NO: 'Norge' || 'NO',
        DK: 'Danmark' || 'DK',
        IS: 'Island' || 'IS',
    },
    VATNumber: 'Momsregistreringsnummer' || 'VATNumber',
    GLNNumber: 'GLN-nummer' || 'GLNNumber',
    ourCustomerNumber: 'Flaivys kundnummer' || 'ourCustomerNumber',
    prognosisOrderCount: 'Prognos antal order per 12 månader' || 'prognosisOrderCount',
    prognosisRevenue: 'Prognos omsättning per 12 månader' || 'prognosisRevenue',
    hasArticlesAtExacta: 'Har artiklar hos Exacta' || 'hasArticlesAtExacta',
    preDefinedAccount: 'Fördefinierat Konto' || 'preDefinedAccount',
    preDefinedAccounts: {
        4000: '4000 - Inköp övriga varor 25%' || '4000',
        4004: '4004 - Inköp Livsmedel LG (12%)' || '4004',
        4005: '4005 - Inköp Livsmedel KM (12%)' || '4005',
        4010: '4010 - Inköp Alkoholhaltiga varor LG (25%)' || '4010',
        4011: '4011 - Inköp Alkoholhaltiga varor KM (25%)' || '4011',
        4014: '4014 - Inköp Alkoholfritt LG (12%)' || '4014',
        4017: '4017 - Inköp Alkoholfritt KM 12%' || '4017',
    },
    exciseNumberAtVinden: 'Eget punktskattenummer hos vinden (om skiljt från flaivys) (13tecken)' ||
        'exciseNumberAtVinden',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    hasPublishedArticles: 'Har denna leverantör publicerade artiklar?' || 'hasPublishedArticles',
};
